import React from 'react';
import {Avatar, ListItem, makeStyles} from '@rn-vui/themed';

import Text from '../../themed/Text';

type StoreNameProps = {
  storeName?: string;
  icon?: any;
};

/**
 * Used on checkout screens
 */
function StoreName({icon, storeName}: StoreNameProps) {
  const styles = useStyles();
  return (
    <ListItem containerStyle={styles.containerStyle}>
      <Avatar>{icon}</Avatar>
      <ListItem.Content>
        <ListItem.Subtitle>
          <Text variant="caption">CHECKOUT</Text>
        </ListItem.Subtitle>
        <ListItem.Title>
          <Text style={styles.title} noMargin variant="heading1">
            {storeName}
          </Text>
        </ListItem.Title>
      </ListItem.Content>
    </ListItem>
  );
}

const useStyles = makeStyles(theme => {
  return {
    containerStyle: {maxWidth: 1320, width: '100%', alignSelf: 'center'},
    subtitle: {},
    title: {
      color: theme.colors.black,
    },
  };
});

export default StoreName;
